<template>
	<thead>
		<tr>
			<th style="background-color: #cecece" colspan="5">
				{{ title }}
			</th>
		</tr>
		<tr>
			<th>Código</th>
			<th>Serviço</th>
			<th>Qnt</th>
			<th>Valor</th>
			<th>Sub total</th>
		</tr>
	</thead>
</template>
<script>
	export default {
		props: ['title'],
	};
</script>



// WEBPACK FOOTER //
// src/components/contracts/components/thead-services.vue